/*
 * @Description:
 * @Author: lz
 * @Date: 2021-09-06 11:33:38
 * @LastEditTime: 2021-09-09 16:54:49
 * @LastEditors: lz
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../layout/index.vue'
import DetailShare from '@/views/businessCenter/caseManage/detailShare'
import CannotShare from '@/views/businessCenter/caseManage/cannotShare'

Vue.use(VueRouter)

const routes = [
  {
    path: '/detailShare',
    name: 'DetailShare',
    hiddren: true, // 在菜单栏隐藏
    component: DetailShare
  },
  {
    path: '/',
    redirect: '/copyright',
    hiddren: true // 在菜单栏隐藏
  },
  {
    path: '/cannotShare',
    hiddren: true, // 在菜单栏隐藏
    component: CannotShare
  },
  {
    path: '/copyright',
    name: 'Copyright',
    meta: { title: '版权登记', icon: 'copyright' },
    redirect: '/copyright/software',
    component: Layout,
    children: [
      {
        path: '/copyright/software',
        name: 'SoftwareCopyright',
        meta: { title: '软件著作权', icon: '' },
        component: () => import(/* webpackChunkName: "copyright" */ '@/views/copyright/software.vue')
      }
    ]
  },
  {
    path: '/businessCenter',
    name: 'BusinessCenter',
    meta: { title: '业务中心', icon: 'businessCenter' },
    component: Layout,
    children: [
      {
        path: '/businessCenter/caseManage',
        name: 'CaseManage',
        meta: { title: '案件管理', icon: '' },
        component: () => import(/* webpackChunkName: "businessCenter" */ '@/views/businessCenter/caseManage/index.vue')
      },
      {
        path: '/businessCenter/caseDetail',
        name: 'CaseDetail',
        hiddren: true,
        meta: { title: '案件详情', icon: '' },
        component: () => import(/* webpackChunkName: "businessCenter" */ '@/views/businessCenter/caseManage/detail.vue')
      },
      {
        path: '/businessCenter/cannotEdit',
        name: 'cannotEdit',
        hiddren: true,
        meta: { title: '案件详情(不可编辑)', icon: '' },
        component: () => import(/* webpackChunkName: "businessCenter" */ '@/views/businessCenter/caseManage/cannotEdit.vue')
      },
      {
        path: '/businessCenter/checkMaterial',
        name: 'checkMaterial',
        hiddren: true,
        meta: { title: '查看材料', icon: '' },
        component: () => import(/* webpackChunkName: "businessCenter" */ '@/views/businessCenter/caseManage/component/checkMaterial.vue')
      },
      {
        path: '/businessCenter/billManage',
        name: 'BillManage',
        meta: { title: '发票管理', icon: '' },
        component: () => import(/* webpackChunkName: "businessCenter" */ '@/views/businessCenter/billManage/index.vue')
      }
    ]
  },
  {
    path: '*',
    name: 404,
    hiddren: true,
    meta: { title: '404' },
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
})

//重定向时报错，用这个不让他报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location)
}
export default router
